module.exports = __webpack_public_path__ + "img/ibmr-branco.e4dd6460.svg";